module.exports = __webpack_public_path__ + "img/28.c86ed70.png";